module.exports = __webpack_public_path__ + "static/media/img3.37cb6fa7.PNG";